import React, { Component } from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';
import LoadingSpinner from "../../common/spinner/loading.component.jsx";
import QuoteEvents from "./events.jsx";

class QuoteEventsTimeLine extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            quote: this.props.quote || null,
            order: this.props.order || null,
            invoice: this.props.invoice || null,
            stockDocument: this.props.stockDocument || null,
            project: this.props.project || null,
            invoices: this.props.invoices || [],
            proposal: this.props.proposal || null,
            contractProposal: this.props.contractProposal || null,
            onUpdate: this.props.onUpdate || function () { },
            emails: this.props.emails || [],
            returns: this.props.returns || [],
            accountStatement: this.props.accountStatement || null,
            proposalEmails: this.props.proposalEmails || [],
            className: this.props.className || '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            quote: nextProps.quote || null,
            order: nextProps.order || null,
            project: nextProps.project || null,
            invoice: nextProps.invoice || null,
            invoices: nextProps.invoices || [],
            proposal: nextProps.proposal || null,
            contractProposal: nextProps.contractProposal || null,
            emails: nextProps.emails || [],
            returns: nextProps.returns || [],
            onUpdate: nextProps.onUpdate || function () { },
            proposalEmails: nextProps.proposalEmails || [],
        })
    }

    getEventBackgroundColor(eventObject) {
        return eventObject && (eventObject.attributes?.deleted || eventObject.attributes?.status === 'transferred') ? 'bg-light' : ''
    }

    hasDocumentWithTimeline() {
        return (((this.state.quote || this.state.invoice || this.state.order || this.state.stockDocument || this.state.accountStatement)
            && this.state.proposal && this.state.emails) || this.props.calendarEvent)
    }

    render() {

        const calendarEvent = this.props.calendarEvent

        if (!this.hasDocumentWithTimeline()) {
            return <LoadingSpinner />
        }
        const events = QuoteEvents.formatQuoteEvents(
            this.state.emails,
            this.state.proposalVisits,
            this.state.quote,
            this.state.order,
            this.state.invoice,
            this.state.project,
            this.state.invoices,
            this.state.proposal ? this.state.proposal.attributes.variables?.document.signatures : [],
            this.state.returns,
            calendarEvent,
            this.state.stockDocument,
            this.state.accountStatement,
            this.state.proposalEmails,
        )


        let feed = []

        events.map(event => {

            const eventDetails = QuoteEvents.getEventComponent(
                event,
                this.state.quote,
                this.state.proposal,
                this.state.invoice,
                this.state.order,
                this.state.onUpdate,
                this.state.stockDocument,
                this.state.accountStatement
            )

            if (eventDetails) {
                feed.push(
                    <div className="feed-item" key={event.id}>
                        <div className={'row'}>
                            <div className="date">
                                <FormattedDate
                                    year='numeric'
                                    month='long'
                                    day='numeric'
                                    weekday='long'
                                    value={new Date(event.date)} />
                                &nbsp;-&nbsp;
                                <FormattedTime
                                    value={new Date(event.date)}
                                />
                            </div>
                        </div>

                        <div className={'text'}>
                            <div className={'row has-ui-module'}>
                                <div className={'col-12 ui-module ' + this.getEventBackgroundColor(event.object)}>
                                    {eventDetails}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

        })

        return <div className={"row " + this.state.className}>
            <div className="col-12">
                <div className="activity-feed">
                    {feed}
                </div>
            </div>
        </div>
    }

}

export default QuoteEventsTimeLine





// WEBPACK FOOTER //
// ./src/quote/analytics/eventstimeline.component.jsx